import { DatabaseOutlined } from "@ant-design/icons";
import { CrudOp, geometryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { KVSSearchView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { brand }) => {
  const authHelper = authHelperCreator(geometryAuthScope);
  return brand != null && authHelper.evaluate(CrudOp.READ, brand);
};

export const kvsSearchViewKey = "geometry_modular_kvs/:brand/search";
export const kvsSearchViewModule: ViewModule = {
  viewKey: kvsSearchViewKey,
  viewEl: <KVSSearchView/>,
  displayNameI18nKey: "kvsSearch:viewName",
  menuIconEl: <DatabaseOutlined/>,
  isAuthorized,
  translations,
};
